import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Tabs from 'UIKit/Tabs'
import styled from 'styled-components'
import colors from 'theme/ui/colors'
import GameTagTab from './GameTagTab'

const StyledIndicator = styled.div`
  border-radius: ${({ theme }) => theme.radii.small};
  background: rgba(255, 255, 255, 0.04);
  height: 100%;
  width: 100%;
`

type GameTagGroupProps = {
  onTagChanged: (value: string) => void
  value: string
  backgroundBlurColor?: string
  tags: string[]
}

const GameTagGroup: React.FC<GameTagGroupProps & BoxProps> = ({
  onTagChanged,
  value,
  backgroundBlurColor,
  tags,
  ...props
}) => {
  return (
    <Box {...props}>
      <Tabs
        value={value}
        onTagChanged={onTagChanged}
        backgroundBlurColor={backgroundBlurColor || colors.background}
        indicator={<StyledIndicator />}
      >
        {tags.map((tag) => {
          return (
            <GameTagTab
              id="game-tag-item"
              selectedValue={value}
              value={tag}
              tagCode={tag}
              key={tag}
              width={`${100 / tags.length}%`}
            />
          )
        })}
      </Tabs>
    </Box>
  )
}

export default GameTagGroup
